import { useCallback } from 'react';

import { ApiSectionNamespace } from '@api';
import { ELogLevel, LoggerType } from '@services/errorService';
import {
  useHttpClientAwaitable,
  GRAPHQL_HEADER,
  httpMethods,
  IGraphQlQuery,
  IHttpClientResponseAwaitable,
} from '@services/httpClientService';

import { CREATE_PAYPAL_ORDER_MUTATION } from './createPayPalOrderMutation';
import { ICreatePayPalOrder, ICreatePayPalOrderResponse } from './model';
import { isCreatePayPalOrderResponse } from './model.guard';

const mappingFunction = (data: ICreatePayPalOrderResponse, logger: LoggerType): ICreatePayPalOrder => {
  if (!isCreatePayPalOrderResponse(data)) {
    logger({ logLevel: ELogLevel.ERROR, logError: new Error('Could NOT decode paypal create order.') });
  }
  return data.paypalCreateOrder.data;
};

export const usePostPayPalOrder = (): IHttpClientResponseAwaitable<ICreatePayPalOrder> => {
  const { request: awaitableRequest } = useHttpClientAwaitable<
    ICreatePayPalOrder,
    IGraphQlQuery,
    ICreatePayPalOrderResponse
  >({
    method: httpMethods.POST,
    path: ApiSectionNamespace.EPaymentApiKeys.PAYMENT_PAYPAL_CREATE_ORDER,
    mappingFunction,
    customHeaders: GRAPHQL_HEADER,
  });

  const request = useCallback(() => {
    return awaitableRequest({ data: { query: CREATE_PAYPAL_ORDER_MUTATION } });
  }, [awaitableRequest]);

  return { request };
};
